import { EngagementStatus, EnvelopeKind, nextStatus, TERMINAL_STATUSES, } from "@collab/protocol";
import { ulid } from "ulid";
export class TransitionError extends Error {
    engagement;
    from;
    kind;
    constructor(engagement, from, kind) {
        super(`engagement ${engagement}: ${kind} is not allowed from ${from}`);
        this.engagement = engagement;
        this.from = from;
        this.kind = kind;
    }
}
export function newEngagement(input, now) {
    const id = `eng_${ulid(now.getTime())}`;
    const at = now.toISOString();
    return {
        id,
        group: input.group ?? id,
        role: input.role,
        counterpart: input.counterpart,
        status: EngagementStatus.enum.draft,
        brief: input.brief,
        created_at: at,
        updated_at: at,
    };
}
/** Applies one envelope kind. Pure: returns a new engagement or throws, never mutates. */
export function apply(e, kind, now) {
    const to = nextStatus(e.status, kind);
    if (!to)
        throw new TransitionError(e.id, e.status, kind);
    return { ...e, status: to, updated_at: now.toISOString() };
}
export const isOpen = (e) => !TERMINAL_STATUSES.has(e.status);
const K = EnvelopeKind.enum;
/** Kinds a person can choose to send; receipt and key_change are sent by the system. */
const SENDABLE = [
    K.request,
    K.clarify,
    K.response,
    K.quote,
    K.agree,
    K.update,
    K.delivery,
    K.review,
    K.cancel,
];
const BY_SIDE = {
    requester: new Set([K.request, K.response, K.agree, K.review, K.cancel, K.clarify]),
    provider: new Set([K.clarify, K.response, K.quote, K.update, K.delivery, K.cancel]),
};
/** Envelope kinds a side may send in the current state, so the UI only offers real actions. */
export function allowedKinds(e) {
    return SENDABLE.filter((k) => nextStatus(e.status, k) && BY_SIDE[e.role].has(k));
}
//# sourceMappingURL=machine.js.map